export default {
  list: {
    title: 'Juego',
    subtitle: 'Lista',
    add: 'Nuevo juego',
    filterStatus: 'Filtro por estado',
    templatePlaceholder: 'Plantilla',
    searchPlaceholder: 'Buscar por algo...',
    tableTitle: 'Juegos activos',
  },
  create: {
    title: 'Agregar',
    subtitle: 'Juegos',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Juego',
    add: 'Nuevo juego',
  },
  templateList: {
    title: 'Plantillas de crucigramas',
    subtitle: 'Lista',
    add: 'Nueva plantilla',
    tableTitle: 'Plantillas activas',
    searchPlaceholder: 'Buscar por algo...',
  },
  templateCreate: {
    title: 'Agregar',
    subtitle: 'Juegos',
  },
  templateEdit: {
    title: 'Editar',
    subtitle: 'Plantilla',
  },
  card: {
    registration: 'Datos de registro',
    template: 'Plantilla del juego',
    actions: 'Acciones',
    publication: 'Publicación',
  },
  preview: {
    title: 'Vista previa de la cuadrícula:',
  },
  form: {
    template: {
      label: 'Iniciar a partir de una plantilla:',
      placeholder: 'Buscar plantillas por nombre',
      apply: 'Aplicar plantilla',
      selected: 'Seleccionado: {name} ({rows}x{columns})',
    },
    name: {
      label: 'Nombre:',
      invalid: 'El nombre es obligatorio',
    },
    prioritizeQuality: {
      label: 'Modo alta densidad',
      tooltip:
        'El sistema realizará múltiples intentos de encaje para garantizar el máximo de palabras cruzadas y evitar espacios vacíos.',
    },
    avoidSimilarWords: {
      label: 'Evitar palabras similares',
      tooltip:
        'El sistema evitará palabras que tengan similitudes significativas con las palabras ya presentes en la cuadrícula.',
    },
    useCurrentGameReference: {
      label: 'Usar el juego actual como base',
      tooltip:
        'Utiliza las posiciones y direcciones de las preguntas de este juego como referencia al generar nuevos juegos.',
    },
    columns: 'Tamaño de columnas:',
    rows: 'Tamaño de filas:',
    style: {
      label: 'Estilo del juego:',
      default: 'Predeterminado',
      radius: 'Redondeado',
      times: 'Fuente Times',
    },
    questionColor: 'Color de la pregunta:',
    font: 'Fuente:',
    level: {
      label: 'Nivel:',
      placeholder: 'Seleccione un nivel',
      easy: 'Fácil',
      medium: 'Medio',
      hard: 'Difícil',
    },
    copyLayout: {
      label: 'Copiar diseño del juego:',
      placeholder: 'Seleccione un juego base...',
    },
    bank: {
      title: 'Banco de respuestas',
      count: 'Cantidad:',
      label: 'Banco:',
    },
    hint: 'Haga doble clic en las celdas para marcarlas como pregunta',
  },
  sidebar: {
    createdAt: 'Creado el:',
    updatedAt: 'Actualizado el:',
    setDraft: 'Cambiar a borrador',
    setCompleted: 'Finalizar juego',
    exportHint: 'Debe guardar antes de exportar.',
    importFile: 'Importar archivo',
    saveAsTemplate: 'Guardar como plantilla',
    saveAndGenerate: 'Guardar y generar nuevo juego',
    emptyGridHint:
      'La cuadrícula no tiene palabras. Inserte nuevas para habilitar.',
    fillWords: 'Insertar palabras',
    noQuestionsHint: 'Marque al menos una pregunta en la cuadrícula.',
    syncQuestions: 'Sincronizar preguntas',
  },
  templatePage: {
    clearTemplate: 'Limpiar plantilla',
  },
  option: {
    answer: 'Respuesta',
    question: 'Pregunta',
    merge: 'Fusionar',
    split: 'Dividir',
    arrows: 'Flechas',
    clearCell: 'Borrar celda',
  },
  answerModal: {
    direction: 'Dirección',
    directionHint: 'a partir de la primera letra',
    directionPlaceholder: 'Seleccione la dirección de llenado',
  },
  questionModal: {
    noQuestions: '¡Esta respuesta no tiene preguntas registradas!',
    textSize: 'Tamaño del texto',
    textSizePlaceholder: 'Seleccione un tamaño',
    fontSize: 'Tamaño de la fuente',
    fontSizePlaceholder: 'Seleccione el tamaño de la fuente',
    required: 'Campo obligatorio',
    registeredQuestions: 'Preguntas registradas',
    levelTooltipTitle: 'Niveles de dificultad:',
    level: 'Nivel',
    levelPlaceholder: 'Seleccione el nivel...',
    levelInvalid: 'El nivel es obligatorio',
    question: 'Pregunta',
    answerLabel: '( Respuesta: {answer} )',
    questionInvalid: 'La pregunta es obligatoria',
    deleteTitle: 'Eliminar pregunta',
    deleteMessage:
      '¿Está seguro de que desea eliminar esta pregunta del sistema?',
  },
  editQuestionModal: {
    title: 'Editar pregunta',
    question: 'Pregunta:',
    questionInvalid: 'La pregunta es obligatoria',
    level: 'Nivel:',
    levelPlaceholder: 'Seleccione el nivel...',
    levelInvalid: 'El nivel es obligatorio',
    warning:
      'Los cambios se reflejarán en el banco de palabras y no solo en este puzzle.',
  },
  arrowsModal: {
    position: 'Posición',
    positionPlaceholder: 'Seleccione la posición',
    direction: 'Dirección',
    directionPlaceholder: 'Seleccione la dirección de llenado',
  },
  ungroupModal: {
    size: 'Tamaño',
    sizePlaceholder: 'Seleccione el tamaño',
  },
  split: {
    third: '1/3 de la fila',
    half: '1/2 de la fila',
    twoThird: '2/3 de la fila',
    twoColumns: '2 columnas',
  },
  saveTemplateModal: {
    title: 'Guardar como plantilla',
    name: 'Nombre:',
    placeholder: 'Ej: Cuadrícula fácil - 15x15',
    hint: 'Esta plantilla guardará solo la posición de las preguntas para reutilizarlas después.',
    save: 'Guardar plantilla',
  },
  importModal: {
    title: 'Importar archivo (.txt)',
    howToFormat: '¿Cómo formatear el archivo?',
    followModel:
      'Siga el modelo a continuación para que la cuadrícula se genere correctamente:',
    letters: 'Letras (A-Z): Celdas rellenadas.',
    dots: 'Punto (.): Celdas vacías.',
    size: 'Tamaño: Todas las filas deben tener la misma cantidad de caracteres.',
    downloadExample: 'Descargar modelo .txt',
    confirm: 'Confirmar importación',
    invalidFormat: 'El formato del archivo debe ser .txt',
    invalidChars:
      '¡Archivo inválido! Use solo letras (A-Z) y puntos (.) para celdas vacías.',
    invalidRows: 'Archivo inválido: las filas tienen tamaños diferentes.',
  },
  unsavedModal: {
    title: 'Cambios no guardados',
    message: 'Hay cambios no guardados. ¿Desea continuar sin guardar?',
    continue: 'Continuar',
  },
  confirm: {
    title: 'Confirmación',
    message: '¿Está seguro de que desea continuar?',
    applyTemplateTitle: 'Confirmar cambio',
    applyTemplateMessage:
      '¿Desea cargar la cuadrícula de "{name}"? Esto reemplazará sus filas y columnas actuales.',
    saveAsTemplateTitle: 'Crear nueva plantilla',
    saveAsTemplateMessage:
      '¿Desea guardar la estructura actual (posiciones de las preguntas) como una nueva plantilla? Las letras actuales se limpiarán en la plantilla guardada.',
    overwriteAnswer:
      'Hay una respuesta en esta dirección, ¿está seguro de que desea continuar?',
    finalizeTitle: 'Finalizar juego',
    finalizeMessage:
      'Este juego será finalizado y no podrá ser editado. ¿Desea continuar?',
    finalize: 'Finalizar',
    syncQuestionsTitle: 'Sincronizar preguntas',
    syncQuestionsMessage:
      'Las respuestas que no tienen preguntas serán revisadas. Si ya existe una pregunta correspondiente, se colocará en la cuadrícula en la celda vinculada a esa respuesta. ¿Desea continuar?',
    syncQuestions: 'Sincronizar',
  },
  alert: {
    sendSuccess: 'Enviado con éxito',
    sendError: 'Error al enviar. Inténtelo de nuevo.',
    statusBatchUpdated: '¡Estados de los juegos actualizados con éxito!',
    statusBatchUpdatedWithSkipped:
      '¡Estado actualizado con éxito! {skipped} juego(s) ya finalizado(s) fueron ignorados.',
    layoutImported: '¡Diseño y coordenadas de las pistas importados con éxito!',
    templateApplied: '¡Plantilla aplicada con éxito!',
    requestCancelled: 'Solicitud cancelada por el usuario',
    fillAnswerFailed: 'No fue posible completar la respuesta',
    bankNotEnough:
      'No hay {count} respuestas únicas disponibles con más de 3 letras en este juego.',
    mergeMergedCell: 'No es posible fusionar otra celda fusionada',
    mergeDirectionOnly:
      'Solo es posible fusionar celdas en horizontal o vertical',
    templateSavedSelected: '¡Plantilla guardada y seleccionada para uso!',
    templateCleared:
      'La plantilla fue limpiada: todas las marcas de pregunta fueron eliminadas',
    generateVariationFailed:
      'No fue posible generar una nueva variación del juego.',
    cannotSaveWithBaseLayout:
      'No es posible guardar y generar variación mientras un diseño base esté importado. Complete las palabras primero o limpie el diseño.',
    saveAsTemplateFirst:
      'Guarde este juego como plantilla antes de generar nuevos juegos.',
    savedLoadingVariation:
      '¡Juego guardado! Cargando la nueva variación generada...',
    savedButVariationFailed:
      'El juego se guardó, pero no fue posible generar una nueva variación. Inténtelo de nuevo.',
    gameSaved: '¡Juego guardado con éxito!',
    statusUpdated: '¡Estado actualizado con éxito!',
    templateSaved: '¡Plantilla guardada con éxito!',
    questionDeleted: '¡Pregunta eliminada con éxito!',
    questionUpdated: '¡Pregunta actualizada con éxito!',
    wordTooLong: 'Palabra demasiado grande',
    readOnly: 'Este juego ya fue finalizado y no puede ser editado.',
    syncQuestionsSuccess: '¡Preguntas sincronizadas con éxito!',
    syncQuestionsError: 'Error al sincronizar preguntas. Inténtelo de nuevo.',
  },
};
